<template>
    <span>
        <span v-if="downloadNumsString.length > 9">
            {{downloadNumsString.substring(0,(downloadNumsString.length-8))}}亿
        </span>
        <span v-else-if="downloadNumsString.length == 9">
            {{downloadNumsString.substring(0,(downloadNumsString.length-8))}}.{{downloadNumsString.substring(1,(downloadNumsString.length-7))}}亿
        </span>
        <span v-else-if="downloadNumsString.length > 5">
            {{downloadNumsString.substring(0,(downloadNumsString.length-4))}}万
        </span>
        <span v-else-if="downloadNumsString.length == 5">
            {{downloadNumsString.substring(0,(downloadNumsString.length-4))}}.{{downloadNumsString.substring(1,(downloadNumsString.length-3))}}万
        </span>
        <span v-else>
            {{downloadNumsString}}
        </span>
    </span>
</template>

<script>
export default {
  name: 'format-down-nums',
  props: ['downloadNums'],
  data () {
    return {
      downloadNumsString: this.downloadNums
    };
  }
};
</script>
